import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./styles/globals.css";

// Warm up Cloud Run on page load so the first API call is fast.
// Only fires when VITE_API_BASE_URL is set (i.e. Firebase Hosting production).
if (typeof window !== "undefined" && import.meta.env.VITE_API_BASE_URL) {
  window.addEventListener("load", () => {
    fetch(`${import.meta.env.VITE_API_BASE_URL}/warmup`, {
      mode: "no-cors",
      cache: "no-store",
    }).catch(() => {});
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
